import React, { useEffect, Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { fetchDelegationData, fetchLeftNavParams } from '@actions/delegation/delegationActionCreators';
import { fetchBrokerConnectData } from '@actions/brokerConnect/brokerConnectActionCreators';
import { brokerNavLinks } from '../individualPortal/navigation/configs/brokerConnectSideNavConfigs';

import NavBarContainer from '../common/NavBarContainer';
import SideNav from '@components/individualPortal/navigation/SideNavigation';

import { configs } from '@constants/configs/configs';
import getRoleGroupByRole from '@utils/dashboard/getRoleGroupbyRole';
import { ALL_USER_ROLES, USER_GROUPS } from '@constants/roles/userRoleTypes';
import { languageTypes } from '@constants/common/languageTypes';


const BrokerConnectContainer = props => {
    const { endpoints } = configs;
    const { 
        actions, 
        environment: {
            stateCode,
            user: {
                role,
                firstName,
                lastName
            },
            language,
            isState,
            impersonation,
            ticketEnabled,
            impersonationDetails
        },
        delegation: {
            leftNavParams = {}
        }
    } = props; 

    let roleGroup = getRoleGroupByRole(role);
    if(impersonation) roleGroup = getRoleGroupByRole(impersonationDetails.role);
    
    useEffect(() => {
        actions.fetchBrokerConnectData(endpoints.BROKERCONNECT_DATA);
        if ( roleGroup === ALL_USER_ROLES.BROKER  || roleGroup === ALL_USER_ROLES.AGENCY_MANAGER || roleGroup === ALL_USER_ROLES.ADMIN || roleGroup === USER_GROUPS.AGENCY_GROUP ) {
            actions.fetchLeftNavParams(endpoints.AGENT_LEFT_NAV_PARAMS);
        }

    }, []);

    const { switchAccUrl, selfDelegationSwitchAccUrl, encryptedBrokerAssisterId } = leftNavParams;   

    const LeftNav = () => {
        return (
            (roleGroup === ALL_USER_ROLES.BROKER  || roleGroup === ALL_USER_ROLES.AGENCY_MANAGER || roleGroup === ALL_USER_ROLES.ADMIN || roleGroup === USER_GROUPS.AGENCY_GROUP) &&
            <Fragment>                
                <SideNav
                    { ...{ stateCode }}
                    navLinks={ brokerNavLinks }
                    userRole={ role }
                    visibilityParams={{ ...leftNavParams, ticketEnabled }}
                    replacements={{ switchAccUrl, encryptedBrokerAssisterId, selfDelegationSwitchAccUrl, lang: language === languageTypes.ENGLISH ? 'en_US' : 'es_ES' }}
                />
            </Fragment>
        );
    };
    
    return (
        <Fragment>
            <div id="brokerConnect-container">
                <div className="grid-container">
                    
                    <div className="grid-row">
                        <NavBarContainer roleGroup={ roleGroup } arrayOfUserRoles={ [ALL_USER_ROLES.BROKER] } houseIcon={ isState.PA } navBarClass='broker-top-nav grid-col-12' />
                    </div>

                    <div className="grid-row margin-y-5 margin-left-1">
                        { impersonationDetails
                            ? <h1>{ impersonationDetails.name }</h1>
                            : <h1>{firstName} {lastName}</h1>
                        }
                    </div>

                    <div className="grid-row grid-gap">
                        <div className="moblie:grid-col desktop:grid-col-3">
                            <LeftNav />
                        </div>
                        <div className="moblie:grid-col desktop:grid-col-9">
                            <Outlet/>
                        </div>
                    </div>

                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    delegation: state.delegation
});

const matchDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchBrokerConnectData,
        fetchDelegationData,
        fetchLeftNavParams
    }, dispatch)
});


export default connect(mapStateToProps, matchDispatchToProps)(BrokerConnectContainer);